import {InputTextV2} from '@prtimes-basis/input';
import {
  FormField,
  useFormField,
} from '@/features/company-registration/steps/input-step/form-field';
import {FieldDescription} from '@/features/company-registration/steps/input-step/form-field/field-description';
import companyRegistrationPageStyles from '@/features/company-registration/styles.module.css';

export function CorporateNameField() {
  return (
    <FormField.Root name='companyInfo.corporateName'>
      <Body />
    </FormField.Root>
  );
}

function Body() {
  const {fieldProps} = useFormField();

  return (
    <>
      <InputTextV2
        required
        placeholder='株式会社PR TIMES'
        wrapperClassName={companyRegistrationPageStyles.sizedInput}
        {...fieldProps}
      />

      <FormField.Error />

      <FieldDescription>
        個人事業主の方は屋号またはサービス名をご入力ください
      </FieldDescription>
    </>
  );
}
